var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "20px",
    viewBox: "0 0 11 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Validera-konto-Copy-7",
    transform: "translate(-720.000000, -117.000000)",
    stroke: "#FFF",
    strokeWidth: 3.48801275
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(673.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(25.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "right",
    transform: "translate(27.500000, 8.000000) scale(-1, 1) rotate(90.000000) translate(-27.500000, -8.000000) ",
    points: "19.5 4.5 27.5 11.5 35.5 4.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhite);
export default __webpack_public_path__ + "static/media/right-white.57f29ac43672082d830cdfc157aa5c5c.svg";
export { ForwardRef as ReactComponent };